var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobotSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5027_14653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 3.8C20.045 3.8 20.9 4.655 20.9 5.7V9.5H28.025C30.3842 9.5 32.3 11.4158 32.3 13.775V29.925C32.3 32.2842 30.3842 34.2 28.025 34.2H9.975C7.61583 34.2 5.7 32.2842 5.7 29.925V13.775C5.7 11.4158 7.61583 9.5 9.975 9.5H17.1V5.7C17.1 4.655 17.955 3.8 19 3.8ZM12.35 26.6C11.8275 26.6 11.4 27.0275 11.4 27.55C11.4 28.0725 11.8275 28.5 12.35 28.5H14.25C14.7725 28.5 15.2 28.0725 15.2 27.55C15.2 27.0275 14.7725 26.6 14.25 26.6H12.35ZM18.05 26.6C17.5275 26.6 17.1 27.0275 17.1 27.55C17.1 28.0725 17.5275 28.5 18.05 28.5H19.95C20.4725 28.5 20.9 28.0725 20.9 27.55C20.9 27.0275 20.4725 26.6 19.95 26.6H18.05ZM23.75 26.6C23.2275 26.6 22.8 27.0275 22.8 27.55C22.8 28.0725 23.2275 28.5 23.75 28.5H25.65C26.1725 28.5 26.6 28.0725 26.6 27.55C26.6 27.0275 26.1725 26.6 25.65 26.6H23.75ZM15.675 19C15.675 17.6858 14.6142 16.625 13.3 16.625C11.9858 16.625 10.925 17.6858 10.925 19C10.925 20.3142 11.9858 21.375 13.3 21.375C14.6142 21.375 15.675 20.3142 15.675 19ZM24.7 21.375C26.0142 21.375 27.075 20.3142 27.075 19C27.075 17.6858 26.0142 16.625 24.7 16.625C23.3858 16.625 22.325 17.6858 22.325 19C22.325 20.3142 23.3858 21.375 24.7 21.375ZM2.85 17.1H3.8V28.5H2.85C1.2825 28.5 0 27.2175 0 25.65V19.95C0 18.3825 1.2825 17.1 2.85 17.1ZM35.15 17.1C36.7175 17.1 38 18.3825 38 19.95V25.65C38 27.2175 36.7175 28.5 35.15 28.5H34.2V17.1H35.15Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5027_14653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotSolid);
export default __webpack_public_path__ + "static/media/robot-solid.03c19a241398a0e115604569d4ae9d00.svg";
export { ForwardRef as ReactComponent };